import { render, staticRenderFns } from "./SalesManagerDetail.vue?vue&type=template&id=1b5393c4&"
import script from "./SalesManagerDetail.vue?vue&type=script&lang=js&"
export * from "./SalesManagerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports